<page-loader *ngIf="!isLoaded"></page-loader>
<div
    id="page-user-listing"
    class="page-section series-form-page"
    *ngIf="isLoaded">
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous" [routerLink]="['/app']">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item app-l-current-page">
                    User Listing
                </li>
            </ul>
        </div>
    </div>

    <div class="page-section-content">
        <my-tabs>
            <!-- External Users Tab -->
            <my-tab tabTitle="External Users">
                <div class="tab-header">
                    <button
                        class="app-c-btn app-c-btn--primary app-c-btn--curve"
                        (click)="createUser('internal')">
                        <svg-icon
                            icon="user-create-icon"
                            class="btn-icon"></svg-icon>
                        Create User
                    </button>
                </div>
                <div class="table-responsive">
                    <!--
                        Filtering dims the rows in place. The old full-screen
                        page-loader flashed over the whole viewport on every
                        keystroke.
                    -->
                    <table
                        class="table user-table"
                        [class.is-filtering]="externalUsersLoading">
                        <thead>
                            <tr>
                                <th translate>userListing.headers.0</th>
                                <th translate>userListing.headers.2</th>
                                <th translate>userListing.headers.3</th>
                                <th translate>userListing.headers.4</th>
                                <th translate>userListing.headers.1</th>
                                <th translate>userListing.headers.8</th>
                                <th class="actions-col"></th>
                            </tr>
                            <tr class="filter-row">
                                <th>
                                    <input
                                        class="filter-control"
                                        type="text"
                                        placeholder="Filter..."
                                        [(ngModel)]="cols[0]"
                                        (input)="valueChange(0)" />
                                </th>
                                <th>
                                    <input
                                        class="filter-control"
                                        type="text"
                                        placeholder="Filter..."
                                        [(ngModel)]="cols[1]"
                                        (input)="valueChange(1)" />
                                </th>
                                <th>
                                    <input
                                        class="filter-control"
                                        type="text"
                                        placeholder="Filter..."
                                        [(ngModel)]="cols[2]"
                                        (input)="valueChange(2)" />
                                </th>
                                <th>
                                    <select
                                        class="filter-control"
                                        [(ngModel)]="cols[3]"
                                        (change)="valueChange(3)">
                                        <option value="">All</option>
                                        <option
                                            *ngFor="
                                                let role of externalUserRoles
                                            "
                                            [value]="role">
                                            {{ role }}
                                        </option>
                                    </select>
                                </th>
                                <th></th>
                                <th>
                                    <select
                                        class="filter-control"
                                        [(ngModel)]="cols[4]"
                                        (change)="valueChange(4)">
                                        <option value="">All</option>
                                        <option
                                            *ngFor="let status of userStatuses"
                                            [value]="status">
                                            {{ status }}
                                        </option>
                                    </select>
                                </th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let user of activeusers
                                        | paginate
                                            : {
                                                  id: 'externalUsers',
                                                  itemsPerPage:
                                                      externalPageSize,
                                                  currentPage:
                                                      externalCurrentPage,
                                                  totalItems:
                                                      externalTotalItems,
                                              }
                                ">
                                <td class="strong">{{ user.fullName }}</td>
                                <td>{{ user.email }}</td>
                                <td
                                    class="organization-cell"
                                    [title]="user.organizationStr">
                                    {{ user.organizationStr }}
                                </td>
                                <td>{{ user.userType }}</td>
                                <td class="subtle">
                                    {{ user.loginOn | date: 'MM/dd/yy' }}
                                </td>
                                <td>
                                    <span
                                        class="status-badge"
                                        [ngClass]="{
                                            'status-approved':
                                                user.status === 'approved',
                                            'status-disabled':
                                                user.status === 'disabled',
                                            'status-unconfirmed':
                                                user.status === 'unconfirmed',
                                        }">
                                        {{ user.status }}
                                    </span>
                                </td>
                                <td class="actions-col">
                                    <button
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        [routerLink]="['/admin/user', user.id]"
                                        title="View">
                                        <svg-icon
                                            icon="eye-icon"
                                            class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        *ngIf="user.status === 'approved'"
                                        (click)="activateUser(user.id, 0)"
                                        title="Disable">
                                        <svg-icon
                                            icon="lock-circle"
                                            class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        *ngIf="user.status === 'disabled'"
                                        (click)="activateUser(user.id, 1)"
                                        title="Approve">
                                        <svg-icon
                                            icon="unlock-circle"
                                            class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20 delete-btn"
                                        *ngIf="user.userType === 'superAdmin'"
                                        (click)="deleteUser(user.id)"
                                        title="Delete">
                                        <svg-icon
                                            icon="trash"
                                            class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="
                                            showInvite('Editinvite', user.id)
                                        "
                                        title="Invite RM">
                                        <svg-icon
                                            icon="invite-user"
                                            class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="externalUsersLoading" class="filtering-note">
                        Filtering&hellip;
                    </p>
                    <p
                        *ngIf="
                            !externalUsersLoading && activeusers.length === 0
                        "
                        class="empty-state">
                        No external users found.
                    </p>
                    <div
                        class="pagination-wrapper"
                        *ngIf="!externalUsersLoading && activeusers.length > 0">
                        <paging-controls
                            id="externalUsers"
                            class="step-pagination"
                            maxSize="5"
                            (pageChange)="
                                onExternalPageChange($event)
                            "></paging-controls>
                    </div>
                </div>
            </my-tab>

            <!-- Internal Users Tab -->
            <my-tab tabTitle="Internal Users">
                <div class="tab-header">
                    <button
                        class="app-c-btn app-c-btn--primary app-c-btn--curve"
                        (click)="showInvite('NewInvite')">
                        <svg-icon
                            icon="user-create-icon"
                            class="btn-icon"></svg-icon>
                        Invite User
                    </button>
                </div>
                <div class="table-responsive">
                    <table
                        class="table user-table"
                        [class.is-filtering]="internalUsersLoading">
                        <thead>
                            <tr>
                                <th translate>userListing.headers.0</th>
                                <th translate>userListing.headers.2</th>
                                <th translate>userListing.headers.3</th>
                                <th translate>userListing.headers.4</th>
                                <th translate>userListing.headers.1</th>
                                <th translate>userListing.headers.8</th>
                                <th class="actions-col"></th>
                            </tr>
                            <tr class="filter-row">
                                <th>
                                    <input
                                        class="filter-control"
                                        type="text"
                                        placeholder="Filter..."
                                        [(ngModel)]="internalCols[0]"
                                        (input)="internalUservalueChange(0)" />
                                </th>
                                <th>
                                    <input
                                        class="filter-control"
                                        type="text"
                                        placeholder="Filter..."
                                        [(ngModel)]="internalCols[1]"
                                        (input)="internalUservalueChange(1)" />
                                </th>
                                <th>
                                    <input
                                        class="filter-control"
                                        type="text"
                                        placeholder="Filter..."
                                        [(ngModel)]="internalCols[2]"
                                        (input)="internalUservalueChange(2)" />
                                </th>
                                <th>
                                    <select
                                        class="filter-control"
                                        [(ngModel)]="internalCols[3]"
                                        (change)="internalUservalueChange(3)">
                                        <option value="">All</option>
                                        <option
                                            *ngFor="
                                                let role of internalUserRoles
                                            "
                                            [value]="role">
                                            {{ role }}
                                        </option>
                                    </select>
                                </th>
                                <th></th>
                                <th>
                                    <select
                                        class="filter-control"
                                        [(ngModel)]="internalCols[4]"
                                        (change)="internalUservalueChange(4)">
                                        <option value="">All</option>
                                        <option
                                            *ngFor="let status of userStatuses"
                                            [value]="status">
                                            {{ status }}
                                        </option>
                                    </select>
                                </th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let user of internalUsers
                                        | paginate
                                            : {
                                                  id: 'internalUsers',
                                                  itemsPerPage:
                                                      internalPageSize,
                                                  currentPage:
                                                      internalCurrentPage,
                                                  totalItems:
                                                      internalTotalItems,
                                              }
                                ">
                                <td class="strong">{{ user.fullName }}</td>
                                <td>{{ user.email }}</td>
                                <td
                                    class="organization-cell"
                                    [title]="user.organizationStr">
                                    {{ user.organizationStr }}
                                </td>
                                <td>{{ user.userType }}</td>
                                <td class="subtle">
                                    {{ user.loginOn | date: 'MM/dd/yy' }}
                                </td>
                                <td>
                                    <span
                                        class="status-badge"
                                        [ngClass]="{
                                            'status-approved':
                                                user.status === 'approved',
                                            'status-disabled':
                                                user.status === 'disabled',
                                            'status-unconfirmed':
                                                user.status === 'unconfirmed',
                                        }">
                                        {{ user.status }}
                                    </span>
                                </td>
                                <td class="actions-col">
                                    <button
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        [routerLink]="['/admin/user', user.id]"
                                        title="View">
                                        <svg-icon
                                            icon="eye-icon"
                                            class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        *ngIf="
                                            user.status === 'approved' &&
                                            user.userType == 'superadmin'
                                        "
                                        (click)="activateUser(user.id, 0)"
                                        title="Disable">
                                        <svg-icon
                                            icon="lock-circle"
                                            class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="
                                            onEditInternalUser(
                                                user.id,
                                                user.userType
                                            )
                                        "
                                        title="Edit">
                                        <svg-icon
                                            icon="edit"
                                            class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="internalUsersLoading" class="filtering-note">
                        Filtering&hellip;
                    </p>
                    <p
                        *ngIf="
                            !internalUsersLoading && internalUsers.length === 0
                        "
                        class="empty-state">
                        No internal users found.
                    </p>
                    <div
                        class="pagination-wrapper"
                        *ngIf="
                            !internalUsersLoading && internalUsers.length > 0
                        ">
                        <paging-controls
                            id="internalUsers"
                            class="step-pagination"
                            maxSize="5"
                            (pageChange)="
                                onInternalPageChange($event)
                            "></paging-controls>
                    </div>
                </div>
            </my-tab>

            <!-- Counselor Sync Tab -->
            <my-tab tabTitle="Counselor Sync">
                <div class="tab-header">
                    <button
                        class="app-c-btn app-c-btn--primary app-c-btn--curve"
                        (click)="createAssociation()">
                        <svg-icon
                            icon="user-create-icon"
                            class="btn-icon"></svg-icon>
                        Create Association
                    </button>
                </div>
                <counselor-user-associations></counselor-user-associations>
            </my-tab>
        </my-tabs>
    </div>
</div>
